import store from '@appStore/store'
import { notificationUtils } from 'features/notifications'
import { appSelectors } from 'redux/reducers/app'
import { NotAuthorizedError } from 'shared/errors'

export function shouldUpgrade(error: Error | string) {
	const isExpired =
		error instanceof NotAuthorizedError &&
		!appSelectors.subscriptionIsActive(store.getState())

	if (isExpired) {
		notificationUtils.snackById('3.17')
	}

	return isExpired
}
